import {ApiError} from '../../../../../util/error';

export function handleNoteError(error: unknown): string {
    if (error instanceof ApiError && Boolean(error.message)) {
        return JSON.parse(error.message)?.text[0] || '';
    }

    return '';
}
